module.exports = require('handlebars/runtime');